import { trpc } from '@client-trpc';
import { useNotifications } from '@client/foundation/notifications/notifications.hook';

const NOTIFICATION_MESSAGES = {
  UPDATE_SUCCESS: 'Successfully set the new keys',
  UPDATE_ERROR: 'Error setting the keys',
  DELETE_SUCCESS: 'Successfully deleted API keys',
  DELETE_ERROR: 'Error deleting API keys'
};

export const useApiManagementApi = () => {
  const { notify } = useNotifications();
  const { data: settings } = trpc.settings.getAllExchangeApiSettings.useQuery();
  const { mutate: updateExchangeApiSettings } =
    trpc.settings.updateExchangeApiSettings.useMutation({
      onSuccess: (updated) => {
        if (updated) {
          notify({
            message: NOTIFICATION_MESSAGES.UPDATE_SUCCESS,
            type: 'success'
          });
        } else {
          notify({
            message: NOTIFICATION_MESSAGES.UPDATE_ERROR,
            type: 'error'
          });
        }
      },
      onError: (error) => {
        notify({
          message: NOTIFICATION_MESSAGES.UPDATE_ERROR,
          type: 'error'
        });

        console.error(error.message);
      }
    });

  const { mutate: deleteExchangeApiSettings } =
    trpc.settings.deleteExchangeApiSettings.useMutation({
      onSuccess: (deleted) => {
        if (deleted) {
          notify({
            message: NOTIFICATION_MESSAGES.DELETE_SUCCESS,
            type: 'success'
          });
        } else {
          notify({
            message: NOTIFICATION_MESSAGES.DELETE_ERROR,
            type: 'error'
          });
        }
      },
      onError: (error) => {
        notify({
          message: NOTIFICATION_MESSAGES.DELETE_ERROR,
          type: 'error'
        });

        console.error(error.message);
      }
    });

  return {
    settings,
    updateExchangeApiSettings,
    deleteExchangeApiSettings
  };
};
